"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"

export function HashScrollFix() {
  const pathname = usePathname()

  useEffect(() => {
    if (typeof window === "undefined") return
    if (window.location.hash) {
      // Try scrolling immediately
      const el = document.getElementById(window.location.hash.slice(1))
      if (el) {
        el.scrollIntoView()
      } else {
        // If not found, try again after a short delay (for async content)
        setTimeout(() => {
          const el2 = document.getElementById(window.location.hash.slice(1))
          if (el2) {
            el2.scrollIntoView()
          }
        }, 300)
      }
    }
  }, [pathname])

  return null
}
